var _defs, _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew197({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 0.5,
    y: 3.61,
    width: 1.01,
    height: 8.78
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 0.5,
    y: 3.61,
    width: 15,
    height: 8.78
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.61,5.39a.78.78,0,1,0-.78-.78h0A.78.78,0,0,0,5.61,5.39Zm-1.4,5.38L4.6,9.06l.81.78v2.32h.78V9.26l-.82-.78.24-1.16a2.79,2.79,0,0,0,2.12,1V7.52a1.91,1.91,0,0,1-1.66-.93L5.68,6A.79.79,0,0,0,5,5.58c-.12,0-.2,0-.31,0l-2,.85V8.29h.78V7l.69-.27L3.56,9.84l-1.9-.39-.15.77,2.7.55Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.19,3.61v8.78H15.5V3.61Zm6.87,4.64h0l-2.88,2.88a.35.35,0,0,1-.5,0h0l-.33-.33a.35.35,0,0,1,0-.5h0l1.78-1.7H8.89a.36.36,0,0,1-.36-.35h0V7.76a.35.35,0,0,1,.35-.35h4.26l-1.78-1.7a.35.35,0,0,1,0-.5h0l.33-.33a.35.35,0,0,1,.5,0h0l2.88,2.88A.37.37,0,0,1,15.06,8.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew197);
export default __webpack_public_path__ + "static/media/Symbolpack_New_197.4316c9f0e17c5fba54550bc565b44a56.svg";
export { ForwardRef as ReactComponent };